'use strict'

/**
 * @classname BtnCancelApplying
 * @classdesc 申請取り下げボタン
 */
export default class BtnCancelApplying {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-cancel-applying')
	 */
	constructor($e, controller) {
		console.log(`BtnCancelApplying.constructor`)
		this._$e = $e
		this._controller = controller
		this._$form = $('#form-cancel-applying')
		this._applyId = this._$e.data('apply-id')
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnCancelApplying
	 * @return {undefined}
	 */
	onClick() {
		console.log(`BtnCancelApplying.onClick`)
		this._$form.find('input.apply_id').val(this._applyId)
	}
}
